import { InjectionToken } from '@angular/core';
import { BottomSheetConfig } from '@ui/domain/bottom-sheet.mode';

export const BOTTOM_SHEET_DEFAULT_CONFIG = new InjectionToken<BottomSheetConfig>('BOTTOM_SHEET_DEFAULT_CONFIG');

export const BOTTOM_SHEET_DATA = new InjectionToken<unknown>('BOTTOM_SHEET_DATA');
